/* eslint-disable @typescript-eslint/no-unused-expressions */
import React, { useEffect, useState } from 'react';
import Carousel from 'react-material-ui-carousel';
import { BasicPlan } from '../plan/BasicPlan';
import { LimitPlan } from '../plan/LimitPlan';
import { CoveragePlan } from '../plan/CoveragePlan';
import { Container, Typography, useTheme, useMediaQuery } from '@mui/material';
import RightVector from '../../../../../assets/images/rightVector.svg';
import LeftVector from '../../../../../assets/images/leftVector.svg';
import { Box } from '@mui/material';

export const PickPlan: React.FC = () => {
  const { breakpoints } = useTheme();
  const isTable = useMediaQuery(breakpoints.down('md'));
  const isMobile = useMediaQuery(breakpoints.down('sm'));

  const plans = [<BasicPlan />, <LimitPlan />, <CoveragePlan />];

  const [heightContainer, setHeightContainer] = useState('');
  const [heightCarousel, setHeightCarousel] = useState('');
  const [posición, setPosición] = useState(0);

  const handleClickMas = (e: any) => {
    setPosición(posición + 1);
  };
  const handleClickMenos = (e: any) => {
    if (posición > 0) {
      setPosición(posición - 1);
    }
  };

  useEffect(() => {
    !isTable
      ? setHeightContainer('550px')
      : !isMobile
      ? setHeightContainer('845px')
      : setHeightContainer('1290px');
    !isTable
      ? setHeightCarousel('306px')
      : !isMobile
      ? setHeightCarousel('615px')
      : setHeightCarousel('1037px');
  }, [isTable, isMobile, posición]);

  return (
    <Container
      maxWidth={!isTable ? 'xl' : 'md'}
      sx={{ height: heightContainer }}
    >
      <Box
        sx={{
          margin: '80px 0 41px 0',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Typography
          component="h2"
          sx={{
            fontSize: isMobile ? '20px' : isTable ? '22px' : '28px',
            fontWeight: 700,
            lineHeight: '34.13px',
            textAlign: 'center',
            width: isMobile ? '233px' : undefined,
          }}
        >
          ¡Elige el plan que más te conviene!
        </Typography>
      </Box>
      <Carousel
        height={heightCarousel}
        autoPlay={false}
        animation={'slide'}
        indicators={false}
        navButtonsAlwaysVisible={true}
        NextIcon={
          <Box
            component={'img'}
            src={RightVector}
            onClick={(e: any) => handleClickMas(e)}
          />
        }
        PrevIcon={
          <Box
            component={'img'}
            src={LeftVector}
            onClick={(e: any) => handleClickMenos(e)}
          />
        }
        navButtonsProps={{
          style: {
            background: 'none',
          },
        }}
        cycleNavigation={false}
      >
        {plans.map((plan, index) => (
          <Box key={index}>
            <Box>{plan}</Box>
          </Box>
        ))}
      </Carousel>
    </Container>
  );
};
